import moment from 'moment-timezone';

/**
 * 格式化数字
 * @param  {[string | number]} number  [要格式化的数字]
 * @param  {[number]} decimals         [保留几位小数]
 * @param  {[string]} dec_point        [小数点符号]
 * @param  {[string]} thousands_sep    [千分位符号]
 * @param  {[string]} roundtag         [舍入参数，默认 "ceil" 向上取,"floor"向下取,"round" 四舍五入]
 * @return {[string]} 格式化后的结果
 */
export function number_format(
  number,
  decimals,
  dec_point,
  thousands_sep,
  roundtag,
) {
  number = number && number.toString().replace(/[^0-9+-Ee.]/g, '');
  roundtag = roundtag || 'ceil'; //"ceil","floor","round"
  const n = !isFinite(Number(number)) ? 0 : Number(number),
    prec = !isFinite(Number(decimals)) ? 0 : Math.abs(decimals),
    sep = typeof thousands_sep === 'undefined' ? ',' : thousands_sep,
    dec = typeof dec_point === 'undefined' ? '.' : dec_point;
  let s = '';
  const toFixedFix = function (n, prec) {
    const k = Math.pow(10, prec);

    return (
      parseFloat(
        Math[roundtag](parseFloat((n * k).toFixed(prec * 2))).toFixed(prec * 2),
      ) / k
    ).toString();
  };
  s = (prec ? toFixedFix(n, prec) : Math.round(n).toString()).split('.');
  const re = /(-?\d+)(\d{3})/;
  while (re.test(s[0])) {
    s[0] = s[0].replace(re, `$1${sep}$2`);
  }

  if ((s[1] || '').length < prec) {
    s[1] = s[1] || '';
    s[1] += new Array(prec - s[1].length + 1).join('0');
  }
  return s.join(dec);
}

/**
 * 去除字符串中的空格
 * @param {*} str
 */
export function trimSpace(str) {
  return str.replace(/\s*/g, '');
}

export function trimHyphen(str) {
  return str.replace(/-/g, '');
}

/**
 * 改变请求中的moduleName变量
 */
export function fixModuleName(str) {
  str = trimHyphen(trimSpace(str));
  str = str.slice(0, 1).toLowerCase() + str.slice(1);
  return str;
}
// 小数加0加百分比
export function formatPercentToString(p) {
  let _num = Number(p);
  _num = `${String(parseFloat((p * 100).toFixed(2)))}`;
  for (let i = 5 - _num.length; i > 0; i--) {
    i === 3 ? (_num += '.') : (_num += '0');
  }
  if (parseFloat(_num) < 0) {
    return `(${_num}%)`;
  }
  return `${_num}%`;
}
/**
 * 首字母大写
 */
export function formatFirstCharacter(str) {
  str = str.slice(0, 1).toUpperCase() + str.slice(1);
  return str;
}

export function formatFirstCharacterWithSpace(item) {
  let str = item.replace(/([A-Z])/g, ' $1');
  str = str.slice(0, 1).toUpperCase() + str.slice(1);
  return str;
}

export const fixZero = (num) => {
  const _num = Number(num);

  if (!_num || Math.abs(_num) >= 10) {
    return num;
  }

  let preFix = '';

  _num < 0 && (preFix = '-');

  if (Math.abs(_num) < 10) {
    return `${preFix}0${_num}`;
  }
};
//change property according to the same property value in array
export const changePropertyInArr = (arr, p, d, targetP, targetPName) => {
  const l = arr.length;
  for (let i = 0; i < l; i++) {
    for (let j = i + 1; j < l; j++) {
      if (arr[i] && arr[j]) {
        if (arr[i][p] === arr[j][p] && arr[i][d] !== arr[j][d]) {
          arr[i][targetP] = targetPName;
          arr[j][targetP] = targetPName;
        }
      }
    }
  }
  return arr;
};

// Param must be Number
export const transformScientificNum = (num) => {
  if (typeof num === 'undefined' || num == null || num.constructor !== Number) {
    return null;
  }
  let numStr = String(num);
  if (!numStr.includes('e')) {
    return numStr;
  }
  const e = parseInt(numStr.split('+')[1], 10) - 20;
  numStr = num / Math.pow(10, e);
  numStr += new Array(e + 1).join('0');
  return numStr;
};

export const splitCamelCaseString = (camelStr, separator = ' ') => {
  if (camelStr.constructor !== String) {
    return '';
  }
  const strBuilder = [];
  let isFirstChar = true;
  for (const char of camelStr) {
    if (isFirstChar) {
      strBuilder.push(char.toUpperCase());
      isFirstChar = false;
      continue;
    }
    if (char === char.toUpperCase()) {
      strBuilder.push(separator);
    }
    strBuilder.push(char);
  }
  return strBuilder.join('');
};

// get EDT or EST of d
export const getEDTOrEST = (d = new Date()) => {
  const edtStart = new Date(),
    estStart = new Date();
  const os = d.getTimezoneOffset();
  const newD = new Date(d);
  edtStart.setMonth(2);
  edtStart.setDate(1);
  edtStart.setDate(15 - edtStart.getDay());
  estStart.setMonth(10);
  estStart.setDate(1);
  estStart.setDate(8 - estStart.getDay());
  const type = d < edtStart || d >= estStart ? 'EST' : 'EDT';
  newD.setMinutes(d.getMinutes() + os - (type === 'EST' ? 300 : 240));
  return { time: newD, type };
};

export const formatDateToEDTRrEST = (date, editor) => {
  if (!date) {
    return null;
  }

  return `Updated ${editor ? `by ${editor}` : ''} ${formatUserLocalDate(date)}`;
};

export const formatDateToYearAndMonth = (date, editor) => {
  if (!date) {
    return null;
  }

  const { time } = getEDTOrEST(date);

  return {
    ym: ` ${moment(time).format(` MMM YYYY`)}`,
    y: ` ${moment(time).format(` YYYY`)}`,
  };
};

export const formatFinancialUploadhistory = (
  date,
  editor,
  isHeader = false,
) => {
  if (!date) {
    return null;
  }

  const formattedDate = formatUserLocalDate(date);
  if (isHeader) {
    return `${editor} ${formattedDate} `;
  }
  return `${formattedDate} Overwritten by: ${editor}`;
};

export const trimStr = (str) => {
  if (!str) {
    return str;
  }
  return str.trim() === '' ? '' : str;
};

export const sortAtoZ = (a, b) => {
  const al = a?.length;
  const bl = b?.length;
  if (!a && !b) {
    return -100;
  }
  if (a && !b) {
    return 100;
  }
  if (!b && a) {
    return -100;
  }
  const l = al > bl ? bl : al;
  for (let i = 0; i < l; i++) {
    if (a?.charCodeAt(i) !== b?.charCodeAt(i)) {
      return a?.charCodeAt(i) - b?.charCodeAt(i);
    }
  }
};

export const formatUserLocalDate = (timestamp) =>
  moment(new Date(timestamp))
    .tz(moment.tz.guess())
    .format('MMM DD, YYYY h:mm A z');

export const formatUserLocalDate3 = (timestamp) =>
  moment(new Date(timestamp))
    .tz(moment.tz.guess(true))
    .format('MM/DD/YYYY h:mm A');
